<template>
    <div class="detail">
        <div class="left">
            <el-card el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span style="font-weight: 600;font-size: 16px">场地预约</span>
                </div>
                <div v-for="(item,index) in cardDataList" :key="index" class="y-card">
                    <el-form ref="ruleForm" label-width="150px" class="demo-ruleForm">
                        <el-form-item label="场地类型 : ">
                            {{item.fieldInfo.fieldTypeName}}
                        </el-form-item>
                        <el-form-item label="所属区域 : ">
                            <router-link style="color: #2568ec;" :to="{name:'platformWay',query:{regionCode:item.regionCode}}">{{item.regionName}}</router-link>
                        </el-form-item>
                        <el-form-item label="场地 : ">
                            <div class="y-places" style="display: flex">
                                <el-select v-model="item.fieldNames" placeholder="请选择场地" @change="changePlaceOption($event,item)">
                                    <el-option
                                            v-for="(pitem,pindex) in placeOptions"
                                            :key="item.pindex"
                                            :label="pitem.name"
                                            :value="pitem.id">
                                    </el-option>
                                </el-select>
                                <el-button style="margin-left: 10px" type="primary" @click="showPlaceMessage(item.fieldIds)">场地信息</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="已预约情况 : ">
                            上午 : {{item.placeSituation.amCount}} 下午 : {{item.placeSituation.pmCount}} 全天 : {{item.placeSituation.allDayCount}}
                        </el-form-item>
                        <el-form-item label="预约时间 : ">
                            {{item.applyTime}}
                        </el-form-item>
                        <el-form-item label="预约时段 : ">
                            {{item.applyTimeIntervalName}}
                        </el-form-item>
                        <el-form-item label="预约来源 : ">
                            {{item.comeFrom}}
                        </el-form-item>
                        <el-form-item label="预约类型 : ">
                            {{item.typeName}}
                        </el-form-item>
                        <el-form-item label="关联项目名称 : ">
                            {{item.businessName}}
                        </el-form-item>
                        <el-form-item label="预约者 : ">
                            {{item.applicant}}
                        </el-form-item>
                        <el-form-item style="width: 100%" label="场地特殊要求 : ">
                            <el-checkbox-group v-model="item.remark">
                                <el-checkbox disabled v-for="(item,index) in supportingList" :key="index" :label="item.id" name="type">{{item.text}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <div class="changeMessage" v-for="(ite,ind) in item.applyChangeList" :key="ind">
                            <el-form-item label="原预约场地 : ">
                                {{ite.fieldNames}}
                            </el-form-item>
                            <el-form-item label="原预约时间 : ">
                                {{ite.applyTime}}
                            </el-form-item>
                            <el-form-item label="原预约时段 : ">
                                {{ite.applyTimeIntervalName}}
                            </el-form-item>
                            <el-form-item label="变更理由 : ">
                                {{ite.reason}}
                            </el-form-item>
                        </div>
                    </el-form>
                    <div class="indexTip">{{index+1}}</div>
                </div>
            </el-card>
            <el-dialog
                    title="场地信息"
                    :visible.sync="dialogVisible"
                    width="60%"
                    center>
            <span>
                <el-form ref="ruleForm" label-width="150px" class="demo-ruleForm">
                        <el-form-item label="所属区域 : ">
                            {{ruleForm.regionName}}
                        </el-form-item>
                        <el-form-item label="场地名称 : ">
                            {{ruleForm.name}}
                        </el-form-item>
                        <el-form-item label="场地类型 : ">
                            {{ruleForm.fieldTypeName}}
                        </el-form-item>
                        <el-form-item label="容纳人数 : ">
                            {{ruleForm.capacity}}
                        </el-form-item>
                        <el-form-item label="每半天可用数 : ">
                            {{ruleForm.halfDayTimes}}
                        </el-form-item>
                        <el-form-item label="摄像头数量 : ">
                            {{ruleForm.cameras}}
                        </el-form-item>
                        <el-form-item label="摄像头开启情况 : ">
                            {{ruleForm.cameraStatusName}}
                        </el-form-item>
                        <el-form-item style="width: 100%" label="配套硬件设备 : ">
                            <el-checkbox-group v-model="ruleForm.supporting">
                                <el-checkbox disabled v-for="(item,index) in supportingList" :key="index" :label="item.id" name="type">{{item.text}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-form>
            </span>
            </el-dialog>
        </div>
        <div class="btns">
            <ul>
                <li><a href="#">场地预约</a></li>
            </ul>
<!--            <el-button v-if="status == '02'" type="primary" @click="passOver('2')">通过</el-button>-->
<!--            <el-button v-if="status == '02'" type="danger"  @click="passOver('3')">不通过</el-button>-->
            <el-button v-if="status == '03'" type="primary" @click="submitForms">调度</el-button>
            <el-button @click.native="tabsCloseCurrentHandle">返回</el-button>
        </div>
    </div>
</template>
<script>
    import {tabsCloseCurrentHandle} from '@/utils/routeTab'
    import {exceptTimeStr} from '@/utils/index'
    import { mapState } from 'vuex'
    export default {
        data(){
            return {
                dialogVisible:false,
                fieldIds:'',
                placeOptions:[],
                cardDataList:[],
                status:'',
                ruleForm:{
                    regionName:'',
                    name:'',
                    fieldTypeName:'',
                    capacity:'',
                    halfDayTimes:'',
                    cameras:'',
                    cameraStatusName:'',
                    supporting:'',
                }
            }
        },
        created(){
            console.log(this.$route.query)
            this.$store.dispatch('region/getSupportingList');
            this.status = this.$route.query.status;
        },
        mounted(){
            this.getDetailMessage();
        },
        computed:{
            ...mapState({
                supportingList:(state) => state.region.supportingList,
            })
        },
        methods:{
            showPlaceMessage(id){
                this.dialogVisible = true;
                this.$http.get('/field/info/get?id='+id)
                    .then(res=>{
                        console.log('审核详情场地detail',res)
                        res.data.data.supporting = res.data.data.supporting.split(',')
                        this.ruleForm = res.data.data;
                    });
            },
            getDetailMessage(){
                this.$http.get('/field/subscribe/getByIds?ids='+this.$route.query.id)
                    .then(res=>{
                        console.log('审核详情detail',res);
                        this.cardDataList = res.data.data;
                        this.cardDataList.forEach((item,index)=>{
                            item.remark = item.remark ? item.remark.split(',') : [];
                            this.getPlaceOption(item);
                            return item;
                        });
                        console.log('22222222222222222',this.cardDataList)
                    });
            },
            getPlaceOption(item){
                this.$http.post('/field/info/list',{
                    "filter": {
                        regionCode:item.regionCode
                    },
                    "orderBy": "create_time desc",
                    "rows": 999,
                }).then(res=>{
                    console.log('placeOption',res);
                    this.placeOptions = res.data.rows;
                })
            },
            changePlaceOption(val,item){
                this.$http.get('/field/subscribe/getFieldApplyCountWith?applyDate='+exceptTimeStr(item.applyTime)+'&fieldId='+val)
                    .then(res=>{
                        item.placeSituation = res.data.data;
                        item.fieldIds = val;
                        console.log('场地预约情况',res);
                    });
            },
            passOver(action){
                this.$http.get('/field/subscribe/updateStatus?action='+action+'&id='+this.$route.query.id)
                    .then(res=>{
                        console.log(res)
                        if(res.data.code == 1){
                            this.$message.success(res.data.msg)
                            this.tabsCloseCurrentHandle();
                        }else{
                            this.$message.error(res.data.msg)
                        }
                    })
            },
            submitForms(){
                this.cardDataList.forEach((item,index)=>{
                    this.$http.post('/field/subscribe/save',{
                        id: item.id,
                        fieldIds: item.fieldIds
                    }).then(res=>{
                        console.log('调度',res)
                        if(res.data.code == 1){
                            this.$message.success(res.data.msg);
                        }else{
                            this.$message.error(res.data.msg);
                        }
                    })
                })
            },
            tabsCloseCurrentHandle(){
                tabsCloseCurrentHandle();
            }
        }
    }
</script>
<style lang="scss" scoped>
    .detail{
        width: 1360px;
        display: flex;
        margin:0 auto;
        .left{
            width:1200px;
            .demo-ruleForm{
                display: flex;
                flex-wrap:wrap;
                /*padding: 0 50px;*/
                .el-form-item{
                    width: 50%;
                    margin:0;
                    /deep/.el-input--medium .el-input__inner{
                        width: 200px;
                    }
                }
                .el-form-item:nth-last-child(2){
                    width: 100%;
                }
                .changeMessage{
                    width: 100%;
                    background: #eeeeee;
                    margin: 10px;
                    display: flex;
                    flex-wrap:wrap;
                    .el-form-item{
                        width: 50%;
                        /deep/.el-input--medium .el-input__inner{
                            width: 200px;
                        }
                    }
                    .el-form-item:nth-child(1),.el-form-item:nth-last-child(1){
                        width: 100%;
                    }
                }
            }
            .y-card{
                margin-bottom: 20px;
                padding: 20px 0;
                border-bottom: 1px solid #eeeeee;
                position: relative;
                .indexTip{
                    width: 20px;
                    height: 30px;
                    background: url(../../../assets/img/index.png) no-repeat 100% 100%;
                    background-size: 100% 100%;
                    text-align: center;
                    line-height: 20px;
                    color: #ffffff;
                    position: absolute;
                    left: 10px;
                    top: 10px;
                }
            }
        }
        .btns{
            width: 150px;
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            border: 1px solid #ebeef5;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            background-color: #fff;
            color: #303133;
            text-align: center;
            padding: 0 10px 10px 10px;
            position:fixed;
            right:150px;
            top:125px;
            .el-button--medium{
                width:100px;
                margin: 5px 0;
            }
            ul{
                width:100px;
                margin-bottom:5px;
                li{
                   a{
                       display: block;
                       padding: 10px 0;
                       text-align:center;
                       border-bottom: 1px solid #ddd;
                       position: relative;
                       color: #1f59a3;
                       cursor: pointer;
                   }
                }
            }
        }
    }
    @media screen and (max-width: 1680px){
        .detail{
           .left{
               width: 1070px;
           }
           .btns{
               right: 80px;
           }
        }
    }
    @media screen and (max-width: 1600px){
        .detail{
            .left{
                width: 1000px;

            }
            .btns{
                right: 80px;
            }
        }
    }
    @media screen and (max-width: 1440px){
        .detail{
           .left{
               width: 850px;
           }
           .btns{
               right: 110px;
           }
        }
    }
</style>